import { Button } from '@jeraisonne/ui';
import { moveById } from '@/features/moves';
import { KitDots, KitScreen, KitStage, MoveCard, type KitToken } from './kit-stage';

/**
 * L'écran qui clôt l'exercice guidé : ce que la trousse contient maintenant. C'est le seul endroit
 * où l'élève voit ce qu'il EMPORTE — l'écran de fin, lui, parle de l'offre.
 *
 * Tout tient sur UN écran de téléphone, bouton compris : les savoirs ont chacun leur carte (ils
 * portent une formule), les gestes sont réunis dans un seul panneau.
 */
export function MovesRecapScreen({
  moves,
  onSignup,
  onContinue,
}: {
  moves: readonly KitToken[];
  onSignup: () => void;
  onContinue: () => void;
}) {
  const many = moves.length > 1;
  const savoirs = moves.filter((m) => m.kind === 'savoir');
  const gestes = moves.filter((m) => m.kind === 'geste');
  return (
    <KitScreen testId="demo-moves-recap">
      <p className="text-xs font-semibold uppercase tracking-[0.16em] text-[#f7d068]">
        {moves.length} Move{many ? 's' : ''} dans ta trousse
      </p>
      <h1 className="font-display mt-1 text-center text-2xl font-bold leading-tight text-white">
        {many ? 'Tu emportes tout ça' : 'Tu emportes ça'}
      </h1>

      <div className="mt-4 w-full space-y-2.5">
        {savoirs.map((m) => (
          <MoveCard key={m.id} kind="savoir" name={m.label} writes={moveById(m.id)?.writes} />
        ))}
        {gestes.length > 0 && (
          <div className="jr-move-card" data-kind="geste" data-testid="move-card-geste">
            <span className="jr-move-card-kind">
              {gestes.length > 1 ? `${gestes.length} gestes` : 'Geste'}
            </span>
            <ul className="flex flex-wrap justify-center gap-x-2 gap-y-1.5">
              {gestes.map((m) => (
                <li
                  key={m.id}
                  className="rounded-full bg-[rgba(146,112,232,0.28)] px-3 py-1 text-base font-bold text-white"
                >
                  {m.label}
                </li>
              ))}
            </ul>
          </div>
        )}
      </div>

      {/* les cartes gagnées, en éventail AU-DESSUS de la trousse où elles sont rangées */}
      <div className="flex w-full flex-1 items-end justify-center pt-16">
        <KitStage open tokens={moves} size={150} />
      </div>

      <div className="mt-2 w-full space-y-2 text-center">
        <p className="text-sm leading-snug text-white/75">
          Un Move gagné reste gagné : il t’attend à tous tes exercices.
        </p>
        {/* « Continuer » et non l'inscription : l'histoire n'est pas finie (l'écran du jeu suit) */}
        <Button variant="gold" size="lg" fullWidth onClick={onContinue}>
          Continuer
        </Button>
        <button
          type="button"
          className="min-h-11 w-full text-sm font-medium text-white/60 underline underline-offset-4"
          onClick={onSignup}
        >
          Créer mon compte gratuit
        </button>
      </div>

      <div className="mt-1">
        <KitDots step={3} />
      </div>
    </KitScreen>
  );
}
